export default "/assets/images/mila-room-showcase-01.webp?6d60b5b6b0cba2a44a80b4d1b6d4eb0a";